const LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL           = 'LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL'
const LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL_SUCCESS   = 'LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL_SUCCESS'
const LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL_FAILED    = 'LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL_FAILED'
const UNMOUNT_DATA_JOBS_CANDIDATE_BY_EMAIL        = 'UNMOUNT_DATA_JOBS_CANDIDATE_BY_EMAIL'

const initialState = {
  loading: true,
  data: null,
  message: null
}

const jobsCandidateByEmailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL:
      return {
        ...state,
        loading: true,
        data: null
      }
    case LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS'
      }
    case LOAD_DATA_JOBS_CANDIDATE_BY_EMAIL_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED'
      }
    case UNMOUNT_DATA_JOBS_CANDIDATE_BY_EMAIL:
      return { 
        ...state, 
        loading: true,
        data: null
      }
    default:
      return state
  }
}

export default jobsCandidateByEmailReducer;